import {
	INVESTOR_TEST_ELEMENT_ID,
	UIElementIdentifier,
} from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Flex, Title } from '@mantine/core';
import { useFormContext } from 'react-hook-form';
import { TextInput } from 'react-hook-form-mantine';

interface Props {
	disabled?: boolean;
	firstNameFieldName: string;
	lastNameFieldName: string;
	emailFieldName: string;
}

export const RepresentativePersonalInformationInput = ({
	firstNameFieldName,
	lastNameFieldName,
	emailFieldName,
	disabled,
}: Props) => {
	const tInvestor = useTranslationInvestor();
	const formContext = useFormContext();

	return (
		<Flex direction="column" gap="1rem" w="100%">
			<Flex direction="column" gap="1rem" w="100%">
				<Title order={6}>
					{tInvestor('investment.personal_details.personal_information')}
				</Title>

				<UIElementIdentifier
					identifier={
						INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_FIRST_NAME
					}
				>
					<TextInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.first_name'
						)}
						placeholder={tInvestor(
							'investment.personal_details.personal_information_form.first_name'
						)}
						name={firstNameFieldName}
						control={formContext.control}
						size="md"
						disabled={disabled}
					/>
				</UIElementIdentifier>

				<UIElementIdentifier
					identifier={
						INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_LAST_NAME
					}
				>
					<TextInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.last_name'
						)}
						placeholder={tInvestor(
							'investment.personal_details.personal_information_form.last_name'
						)}
						name={lastNameFieldName}
						control={formContext.control}
						size="md"
						disabled={disabled}
					/>
				</UIElementIdentifier>

				<UIElementIdentifier
					identifier={
						INVESTOR_TEST_ELEMENT_ID.INVESTOR_PERSONAL_INFORMATION_REPRESENTATIVE_EMAIL
					}
				>
					<TextInput
						label={tInvestor(
							'investment.personal_details.personal_information_form.email'
						)}
						placeholder={tInvestor(
							'investment.personal_details.personal_information_form.email'
						)}
						name={emailFieldName}
						control={formContext.control}
						size="md"
						disabled={disabled}
					/>
				</UIElementIdentifier>
			</Flex>
		</Flex>
	);
};
